import 'moment-precise-range-plugin'
import * as moment from 'moment'
import {
  years, months, days, hours, minutes, seconds,
  declinationLabels,
  Labels,
} from '@/helpers/declinationLabels'


declare module 'moment' {
  interface Moment {
    preciseDiff(d2: Moment, flag: boolean): Moment;
    preciseDiffLocal(d2: Moment, options?: PreciseDiffOptions): string;
  }

  export function preciseDiff(d1: Moment, d2: Moment, flag: boolean): Required<Declines<number>>
  export function preciseDiffLocal(d1: Moment, d2: Moment, options?: PreciseDiffOptions): string
}


interface Declines<T> {
  years?: T;
  months?: T;
  days?: T;
  hours?: T;
  minutes?: T;
  seconds?: T;
}

interface PreciseDiffOptions extends Declines<boolean> {
  short?: boolean;
  delimiter?: string;
  count?: number;
}

const DECLINES: Declines<Labels> = {
  years,
  months,
  days,
  hours,
  minutes,
  seconds,
}

const SHORT_DECLINES: Declines<Labels> = Object
  .keys(DECLINES)
  .reduce((acc, key) => {
    const value = DECLINES[key as keyof Declines<Labels>] as Labels
    const result = value.map<string>((_) => _[0]) as Labels
    acc[key as keyof Declines<Labels>] = result
    return acc
  }, {} as Declines<Labels>)

const DEFAULT_OPTIONS: PreciseDiffOptions = {
  years: true,
  months: true,
  days: true,
  hours: true,
  minutes: true,
  seconds: true,

  short: false,
  delimiter: ' ',
  count: 10,
}

function preciseDiffLocalFn(
  this: moment.Moment,
  d2: moment.Moment,
  options: PreciseDiffOptions,
) {
  return moment.preciseDiffLocal(this, d2, options)
}

function preciseDiffLocalMoment(
  this: moment.Moment,
  d1: moment.Moment,
  d2: moment.Moment,
  rawOptions: PreciseDiffOptions,
) {
  const options: PreciseDiffOptions = {
    ...DEFAULT_OPTIONS,
    ...(rawOptions || { delimiter: DEFAULT_OPTIONS.delimiter }),
  }

  const preciseObject: Record<string, number> = moment.preciseDiff(d1, d2, true)
  const declines = options.short ? SHORT_DECLINES : DECLINES

  const result = (Object.keys(declines) as Array<keyof typeof declines>).map((key) => {
    const count = preciseObject[key]
    if (!count || !options[key]) return undefined

    const decline = declines[key]
    if (!decline) return count

    return [
      count,
      key in declines ? declinationLabels(count, decline) : count,
    ].filter(Boolean).join(options.short ? '' : ' ')
  })
    .filter(Boolean)
    .slice(0, options.count)
    .join(options.delimiter)

  if (!result && preciseObject.seconds) {
    return 'Недавно'
  }

  return result
}

moment.fn.preciseDiffLocal = preciseDiffLocalFn
// @ts-ignore TODO:
moment.preciseDiffLocal = preciseDiffLocalMoment
